/*
 * Copyright 2017-2020 Narbase technologies and contributors. Use of this source code is governed by the MIT License.
 */
package com.narbase.letsgo.router


enum class Authentication(val configurationName: String) {
    JWT(AuthenticationConstants.JWT_HEADER_AUTH_CLIENT),
    PassengerBasicAuth(AuthenticationConstants.PASSENGER_BASIC_AUTH_CLIENT),
    DriverBasicAuth(AuthenticationConstants.DRIVER_BASIC_AUTH_CLIENT),
    AdminBasicAuth(AuthenticationConstants.ADMIN_BASIC_AUTH_CLIENT),
}

object AuthenticationConstants {
    const val BASIC_AUTH = "BasicAuth"

    const val PASSENGER_BASIC_AUTH_CLIENT = "PassengerBasicAuthClient"
    const val DRIVER_BASIC_AUTH_CLIENT = "DriverBasicAuthClient"
    const val ADMIN_BASIC_AUTH_CLIENT = "AdminBasicAuthClient"

    const val JWT_HEADER_AUTH_CLIENT = "JwtHeaderAuthClient"
}